// @module TavanoTeam.CapSciExtensions.CSSearchSpringExt
define('TavanoTeam.CapSciExtensions.CSSearchSpringExt.ItemsSearcher.View'
,	[
		'ItemsSearcher.View'
	,	'SiteSearch.View'

	,	'tavanoteam_capsciextension_cssearchspringext_itemssearcher.tpl'

	,	'underscore'
	,	'jQuery'
	]
,   function (
		ItemsSearcherView
	,	SiteSearchView

	,	tavanoteam_capsciextension_cssearchspringext_itemssearcher_tpl

	,	_
	,	jQuery
	)
{
	'use strict';

	return ItemsSearcherView.extend({
		defaultOptions: _.extend({}, ItemsSearcherView.prototype.defaultOptions, {
			template: tavanoteam_capsciextension_cssearchspringext_itemssearcher_tpl
		})
	});

	// return  {
	// 	loadSearchSpringItemsSearcher: function loadSearchSpringItemsSearcher (container)
	// 	{
	// 		_.extend(ItemsSearcherView.prototype, {
	// 			defaultOptions: _.extend(ItemsSearcherView.prototype.defaultOptions, {
	// 				template: tavanoteam_capsciextension_cssearchspringext_itemssearcher_tpl
	// 			})
    //         });
	// 	}
	// };
});
